module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "menu"
    }
  }, [_c('b-navbar', {
    attrs: {
      "toggleable": "md",
      "type": "light"
    }
  }, [_c('b-nav-toggle', {
    staticClass: "mb-3",
    attrs: {
      "label": "Exibir/Esconder Menu",
      "target": "navbarNav"
    }
  }, [_c('icon', {
    staticStyle: {
      "color": "#FFF"
    },
    attrs: {
      "name": "bars",
      "scale": "2"
    }
  })], 1), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "is-nav": "",
      "id": "navbarNav"
    }
  }, [_c('b-nav', {
    attrs: {
      "is-nav-bar": ""
    }
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/quem-somos"
    }
  }, [_vm._v("Quem Somos")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/produtos"
    }
  }, [_vm._v("Produtos")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/seja-um-parceiro",
      "exact": ""
    }
  }, [_vm._v("Seja um parceiro")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/novidades"
    }
  }, [_vm._v("Novidades")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/contato"
    }
  }, [_vm._v("Contato")])], 1)])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-197f2280","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/src/partials/Menu.vue
// module id = 867
// module chunks = 0